export { default } from "./useContentMetadataGet";
